import { Box, Skeleton, Stack, styled } from '@mui/material';

import { Link } from '@/design-system';
import { forMobile } from '@/styles/responsive';

export const UserListItemWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1.9fr 1.7fr 1.5fr 1.3fr 1.3fr 1.5fr 180px',
  backgroundColor: '#222833',
  border: 'none',
  padding: '16px',
  borderRadius: '12px',
  minWidth: '1200px',
  width: '100%',
  alignItems: 'center',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: '#191D26',
  },
});

export const FundsTableContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '300px 200px 200px auto',
  padding: '10px 16px',
  alignItems: 'center',
  border: '1px solid #2E2E35',
  borderRadius: '12px',
  minWidth: '1260px',
  width: '100%',
});

export const InvestmentsTableContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  padding: '16px',
  border: '1px solid #2E2E35',
  borderRadius: '16px',
  alignItems: 'center',
  minWidth: '1200px',
  width: '100%',
});

export const EmptyStateWrapper = styled(Stack)({
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
});

export const ScrollWrapper = styled('div')({
  position: 'relative',
  width: '100%',
});

export const FakeScrollbarTrack = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: '8px',
  background: '#1F1F25',
  border: '1px solid #2E2E35',
  borderRadius: '8px',
  zIndex: 2,
});

export const FakeScrollbarThumb = styled('div')({
  height: '100%',
  background: '#47474F',
  borderRadius: '8px',
  position: 'absolute',
  left: 0,
  top: 0,
  cursor: 'grab',
  ['&:active']: {
    cursor: 'grabbing',
  },
});

export const ProfileDetailsContainer = styled(Stack)(({ theme }) => {
  return {
    padding: '7px 10px',
    border: '1px solid #161D29',
    marginBottom: '7px',
    borderRadius: '8px',
    gap: '26px',
    alignItems: 'center',
    flexDirection: 'row',

    [forMobile(theme)]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  };
});

export const SkeletonRow = styled(Skeleton)({
  height: 70,
  width: '100%',
  borderRadius: 12,
  transform: 'none',
  backgroundColor: '#1B202B',
});

export const SkeletonBox = styled(Skeleton)({
  width: '100%',
  borderRadius: 6,
  transform: 'none',
  backgroundColor: '#2D3340',
});

export const OverviewFiltersScroll = styled(Box)({
  minHeight: '65px',
  width: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const SocialLinkWrapper = styled(Link)({
  padding: '12px',
  background: '#222833',
  width: 40,
  height: 40,
  borderRadius: '8px',
});
